import React from 'react';
import { Section } from '../ui/Section';
import { Brain, Clock, Trash2 } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: Brain,
    title: '¿Qué cocino hoy?',
    desc: 'La pregunta de todos los días. Pensar menús agota más que cocinar.'
  }, {
    icon: Clock,
    title: 'Siempre lo mismo',
    desc: 'Repetís las mismas 5 comidas porque no tenés tiempo de buscar ideas nuevas.'
  }, {
    icon: Trash2,
    title: 'Compras sin plan',
    desc: 'Vas al súper sin lista, comprás de más y la mitad termina en la basura.'
  }];
  return <Section className="bg-brand-slate-50" data-id="element-204">
      <div className="text-center mb-6 md:mb-10" data-id="element-205">
        <h2 className="text-2xl md:text-4xl font-bold text-brand-slate-900 mb-3 md:mb-4" data-id="element-206">
          ¿Te suena familiar?
        </h2>
        <p className="text-sm md:text-base text-brand-slate-600 max-w-xl mx-auto" data-id="element-207">
          El estrés de la cocina diaria es real. Pero tiene solución.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6" data-id="element-208">
        {problems.map((problem, i) => <div key={i} className="bg-white p-5 md:p-6 rounded-2xl border border-brand-slate-200" data-id="element-209">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-red-50 flex items-center justify-center mb-3 md:mb-4" data-id="element-210">
              <problem.icon className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-211" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-brand-slate-900 mb-2" data-id="element-212">
              {problem.title}
            </h3>
            <p className="text-brand-slate-600 text-sm leading-relaxed" data-id="element-213">
              {problem.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}